import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface RunFlowsParams {
  readonly ids: string[];
  readonly isRunAllIncremental: boolean;
}

export interface RunFlowsResult extends IResult {
}

export class RunFlowsRequest extends Request<RunFlowsParams, RunFlowsResult> {
  constructor(ids: string[], isRunAllIncremental: boolean) {
    super('runFlows', { ids: ids, isRunAllIncremental });
  }
}


